module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-banner-be.0ba53e99.png";